class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 100);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .rr-product-count .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const coll = gridContainer.querySelector('.collection');
      if (coll) coll.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }
    const rrCount = document.querySelector('.rr-product-count');
    if (rrCount) rrCount.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countSrc = parsed.getElementById('ProductCount') || parsed.getElementById('ProductCountDesktop');
    const count = countSrc ? countSrc.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const rrCount = document.querySelector('.rr-product-count');
    if (rrCount) rrCount.classList.remove('loading');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner, .rr-product-count .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const fromSource = html.querySelector(selector);
      const onPage = document.querySelector(selector);
      if (!fromSource || !onPage) return;
      onPage.innerHTML = fromSource.innerHTML;
    });

    // Update the Rare Rabbit bar: desktop product count + tab nav counts + active pills row
    const rrCountSrc = html.querySelector('#ProductCountDesktop');
    const rrCountDom = document.getElementById('ProductCountDesktop');
    if (rrCountSrc && rrCountDom) {
      rrCountDom.innerHTML = rrCountSrc.innerHTML;
      rrCountDom.classList.remove('loading');
    }

    const rrNavSrc = html.querySelector('.rr-filter-drawer__nav');
    const rrNavDom = document.querySelector('.rr-filter-drawer__nav');
    if (rrNavSrc && rrNavDom) {
      // Preserve which tab is active on the client
      const activeIdx = rrNavDom.querySelector('.rr-filter-drawer__nav-item.is-active')?.getAttribute('data-rr-filter-tab');
      rrNavDom.innerHTML = rrNavSrc.innerHTML;
      if (activeIdx) {
        rrNavDom.querySelectorAll('.rr-filter-drawer__nav-item').forEach((b) => b.classList.remove('is-active'));
        const match = rrNavDom.querySelector(`.rr-filter-drawer__nav-item[data-rr-filter-tab="${activeIdx}"]`);
        if (match) match.classList.add('is-active');
      }
    }

    // v10: Update the FILTER button dot indicator after AJAX filter change.
    // The button lives in the RR bar (not inside FacetFiltersForm) so we have
    // to sync it separately from the source HTML.
    const rrFilterBtnSrc = html.querySelector('.rr-filter-btn');
    const rrFilterBtnDom = document.querySelector('.rr-filter-btn');
    if (rrFilterBtnSrc && rrFilterBtnDom) {
      const srcHasActive = rrFilterBtnSrc.classList.contains('rr-filter-btn--active');
      rrFilterBtnDom.classList.toggle('rr-filter-btn--active', srcHasActive);
      // Sync the dot element (add or remove as needed)
      const existingDot = rrFilterBtnDom.querySelector('.rr-filter-dot');
      const newDot = rrFilterBtnSrc.querySelector('.rr-filter-dot');
      if (newDot && !existingDot) {
        rrFilterBtnDom.appendChild(newDot.cloneNode(true));
      } else if (!newDot && existingDot) {
        existingDot.remove();
      }
    }

    const rrPillsSrc = html.querySelector('#FacetFiltersPillsForm .active-facets-desktop');
    const rrPillsDom = document.querySelector('#FacetFiltersPillsForm .active-facets-desktop');
    if (rrPillsSrc && rrPillsDom) {
      rrPillsDom.innerHTML = rrPillsSrc.innerHTML;
    }

    // Toggle the empty state on the pills form wrapper
    const rrPillsWrapSrc = html.querySelector('.facets-pill');
    const rrPillsWrapDom = document.querySelector('.facets-pill');
    if (rrPillsWrapSrc && rrPillsWrapDom) {
      if (rrPillsWrapSrc.classList.contains('rr-pills-empty')) {
        rrPillsWrapDom.classList.add('rr-pills-empty');
      } else {
        rrPillsWrapDom.classList.remove('rr-pills-empty');
      }
    }

    const mobileDrawer = document.getElementById('FacetFiltersFormMobile');
    if (mobileDrawer && mobileDrawer.closest('menu-drawer')) {
      mobileDrawer.closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ===============================================================
   RARE RABBIT bar behavior:
   - Sort dropdown toggle (click FILTER / SORT BY buttons)
   - Filter drawer open/close
   - 1/2/4 column grid view switcher (instant, client-side)
   - Close on outside click / Escape
   =============================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // ---- Sort dropdown ----
  function initSortToggle() {
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-rr-sort-toggle]');
      if (toggle) {
        e.preventDefault();
        const wrapper = toggle.closest('.rr-sort-wrapper');
        if (!wrapper) return;
        const panel = wrapper.querySelector('[data-rr-sort-panel]');
        if (!panel) return;
        const isOpen = !panel.hasAttribute('hidden');
        // Close any other open panels
        document.querySelectorAll('[data-rr-sort-panel]').forEach((p) => {
          if (p !== panel) p.setAttribute('hidden', '');
        });
        if (isOpen) {
          panel.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          panel.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      // Click outside any sort panel closes all
      if (!e.target.closest('.rr-sort-panel') && !e.target.closest('[data-rr-sort-toggle]')) {
        document.querySelectorAll('[data-rr-sort-panel]').forEach((p) => p.setAttribute('hidden', ''));
        document.querySelectorAll('[data-rr-sort-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
    });

    // When a sort option is chosen, close the panel immediately AND
    // force-submit the form so sorting applies in ~100ms (debounce).
    document.addEventListener('change', function (e) {
      const input = e.target;
      if (input && input.matches && input.matches('.rr-sort-panel input[type="radio"]')) {
        // Visually update selected state
        const panel = input.closest('.rr-sort-panel');
        if (panel) {
          panel.querySelectorAll('.rr-sort-option').forEach((opt) => opt.classList.remove('is-selected'));
          const lbl = input.closest('.rr-sort-option');
          if (lbl) lbl.classList.add('is-selected');
          // Close the dropdown
          setTimeout(() => {
            panel.setAttribute('hidden', '');
            const toggleBtn = panel.closest('.rr-sort-wrapper')?.querySelector('[data-rr-sort-toggle]');
            if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
          }, 80);
        }
      }
    });

    // Escape closes the dropdown
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-rr-sort-panel]').forEach((p) => p.setAttribute('hidden', ''));
        document.querySelectorAll('[data-rr-sort-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      }
    });
  }

  // ---- Filter drawer ----
  function initFilterDrawer() {
    document.addEventListener('click', function (e) {
      const opener = e.target.closest('[data-rr-open-filter]');
      if (opener) {
        e.preventDefault();
        const drawer = document.querySelector('[data-rr-filter-drawer]');
        if (!drawer) return;
        drawer.removeAttribute('hidden');
        document.body.classList.add('rr-filter-drawer-open');
        return;
      }
      const closer = e.target.closest('[data-rr-close-filter]');
      if (closer) {
        e.preventDefault();
        const drawer = document.querySelector('[data-rr-filter-drawer]');
        if (!drawer) return;
        drawer.setAttribute('hidden', '');
        document.body.classList.remove('rr-filter-drawer-open');
        return;
      }
      // Tab switch inside the drawer
      const tab = e.target.closest('[data-rr-filter-tab]');
      if (tab) {
        e.preventDefault();
        const idx = tab.getAttribute('data-rr-filter-tab');
        const drawer = tab.closest('.rr-filter-drawer');
        if (!drawer) return;
        drawer.querySelectorAll('[data-rr-filter-tab]').forEach((b) => b.classList.remove('is-active'));
        drawer.querySelectorAll('[data-rr-filter-pane]').forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        const pane = drawer.querySelector('[data-rr-filter-pane="' + idx + '"]');
        if (pane) pane.classList.add('is-active');
      }
    });

    // Escape closes drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const drawer = document.querySelector('[data-rr-filter-drawer]');
        if (drawer && !drawer.hasAttribute('hidden')) {
          drawer.setAttribute('hidden', '');
          document.body.classList.remove('rr-filter-drawer-open');
        }
      }
    });
  }

  // ---- Grid view switcher (1 / 2 / 4 columns) ----
  function initViewSwitcher() {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-rr-cols]');
      if (!btn) return;
      e.preventDefault();
      const cols = parseInt(btn.getAttribute('data-rr-cols'), 10);
      if (!cols) return;

      const grid = document.getElementById('product-grid');
      if (!grid) return;

      // Briefly mark the container as "switching" for a tiny fade
      const container = document.getElementById('ProductGridContainer');
      if (container) {
        container.classList.add('is-switching');
        setTimeout(() => container.classList.remove('is-switching'), 180);
      }

      // Remove any current desktop-col class and set the new one
      grid.className = grid.className
        .split(/\s+/)
        .filter((c) => !/^grid--\d+-col-desktop$/.test(c))
        .join(' ');
      grid.classList.add('grid--' + cols + '-col-desktop');

      // Toggle active state on buttons
      document.querySelectorAll('[data-rr-cols]').forEach((b) => b.classList.remove('rr-view-btn--active'));
      btn.classList.add('rr-view-btn--active');

      // Persist the user's choice for this session so it survives
      // AJAX re-renders after sorting/filtering
      try {
        sessionStorage.setItem('rrDesktopCols', String(cols));
      } catch (err) {
        /* ignore */
      }
    });
  }

  // Re-apply saved column preference after an AJAX filter/sort re-render.
  // FacetFiltersForm.renderProductGridContainer rebuilds #ProductGridContainer
  // innerHTML, so we observe it and re-apply our class.
  function initColumnPreferencePersistence() {
    const reapply = () => {
      let saved = null;
      try {
        saved = sessionStorage.getItem('rrDesktopCols');
      } catch (err) {
        /* ignore */
      }
      if (!saved) return;
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      const cols = parseInt(saved, 10);
      if (!cols) return;
      if (!grid.classList.contains('grid--' + cols + '-col-desktop')) {
        grid.className = grid.className
          .split(/\s+/)
          .filter((c) => !/^grid--\d+-col-desktop$/.test(c))
          .join(' ');
        grid.classList.add('grid--' + cols + '-col-desktop');
      }
      // Mark correct button active (in case bar was also re-rendered)
      document.querySelectorAll('[data-rr-cols]').forEach((b) => {
        if (parseInt(b.getAttribute('data-rr-cols'), 10) === cols) {
          b.classList.add('rr-view-btn--active');
        } else {
          b.classList.remove('rr-view-btn--active');
        }
      });
    };

    // Also: on load, if default-desktop-cols exists and no saved pref,
    // mark the matching button active.
    const grid = document.getElementById('product-grid');
    if (grid) {
      let saved = null;
      try {
        saved = sessionStorage.getItem('rrDesktopCols');
      } catch (err) {
        /* ignore */
      }
      if (!saved) {
        const def = grid.getAttribute('data-default-desktop-cols');
        if (def) {
          document.querySelectorAll('[data-rr-cols]').forEach((b) => {
            b.classList.remove('rr-view-btn--active');
            if (b.getAttribute('data-rr-cols') === def) b.classList.add('rr-view-btn--active');
          });
        }
      } else {
        reapply();
      }
    }

    // Observe the container for AJAX re-renders and re-apply.
    const container = document.getElementById('ProductGridContainer');
    if (container && 'MutationObserver' in window) {
      let isReapplying = false;
      const obs = new MutationObserver(() => {
        if (isReapplying) return;
        isReapplying = true;
        try { reapply(); } finally {
          // release on next tick
          setTimeout(() => { isReapplying = false; }, 0);
        }
      });
      obs.observe(container, { childList: true, subtree: true });
    }
  }

  ready(function () {
    initSortToggle();
    initFilterDrawer();
    initViewSwitcher();
    initColumnPreferencePersistence();
  });
})();
